import styled from '@emotion/styled'
import {PALETTE} from '../styles/paletteV3'

const DialogContent = styled('div')({
  color: PALETTE.SLATE_700,
  fontSize: 14,
  lineHeight: 1.5,
  padding: '16px 24px 24px'
})

export default DialogContent
